import { render, staticRenderFns } from "./Product1102001000012ogcbd.vue?vue&type=template&id=0b839f4b"
import script from "./Product1102001000012ogcbd.vue?vue&type=script&lang=js"
export * from "./Product1102001000012ogcbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b839f4b')) {
      api.createRecord('0b839f4b', component.options)
    } else {
      api.reload('0b839f4b', component.options)
    }
    module.hot.accept("./Product1102001000012ogcbd.vue?vue&type=template&id=0b839f4b", function () {
      api.rerender('0b839f4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1102001000012ogcbd.vue"
export default component.exports